export default class Logger {
  private readonly _prefix: string;
  private readonly _debug: boolean;

  constructor(module: string, debug?: boolean) {
    this._prefix = `${module.toUpperCase()} →`;
    this._debug = debug !== undefined
      ? debug
      : process.env.NODE_ENV === 'development';
  }

  private stringifyArgs(args: any[]): any[] {
    return args.map(a => {
      if (typeof a === 'object') {
        return JSON.stringify(a);
      }
      return a;
    });
  }

  private joinArgs(args: any[]): string {
    return args.join(',').replace(/,/g, ' ');
  }

  public info(...args) {
    if (!this._debug) return;
    const stringifiedArgs = this.stringifyArgs(args);
    console.log(`${this._prefix} ${this.joinArgs(stringifiedArgs)}`);
  }

  public error(...args) {
    if (!this._debug) return;
    const stringifiedArgs = this.stringifyArgs(args);
    console.error(`${this._prefix} ${this.joinArgs(stringifiedArgs)}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/logger.ts